import React from 'react';
import PropTypes from 'prop-types';

import MuiButton from '@material-ui/core/Button';

import { useRedirectButtonRoundStyles } from './styles';

const RedirectButtonRound = ({ children, bold, noTextTransform, width, height, ...rest }) => {
	const classes = useRedirectButtonRoundStyles({
		noTextTransform,
		height,
		width,
		rest
	});

	return (
		<MuiButton disableElevation width={width} height={height || 'auto'} classes={classes} {...rest}>
			{children}
		</MuiButton>
	);
};

RedirectButtonRound.propTypes = {
	children: PropTypes.node.isRequired,
	fullWidth: PropTypes.bool,
	height: PropTypes.number
};

export default RedirectButtonRound;
